import { isNotNullish, isNullish } from 'utils/nullish';
import { notification } from 'antd';
import { isPcOrLinux } from 'utils/platform';
import moment from 'moment';

export const AdvancedSearchUtil = Object.freeze({
  // 对齐和扩展es里issue的信息
  enrichIssueEsMap(pid, esMap) {
    if (isNullish(esMap)) {
      return {};
    }
    if (isNullish(pid)) {
      notification.error({ message: 'enrichIssueEsMap pid is null!' });
      return esMap;
    }
    let firstUploadTimeFormatted = '-';
    const { firstTimestamp, firstTime, issueErrorType, faultIp } = esMap;
    if (isPcOrLinux(pid)) {
      firstUploadTimeFormatted = moment(1000 * firstTimestamp).format('YYYY-MM-DD HH:mm:ss');
    } else {
      firstUploadTimeFormatted = firstTime;
    }
    const expName = isPcOrLinux(pid) ? faultIp : issueErrorType;

    return {
      firstUploadTimeFormatted,
      expName,
      ...esMap,
    };
  },

  /** 归档 tab：把 archivedCrashList（CrashMap JSON）拼成 ReportRecord 要的 crashResp。 */
  buildArchivedCrashResp(archivedCrashList, totalCount) {
    const list = Array.isArray(archivedCrashList) ? archivedCrashList : [];
    const crashIdList = [];
    const crashDatas = {};
    list.forEach((item) => {
      if (!item) {
        return;
      }
      const crashId = item.crashId || item.crashHash;
      if (!crashId) {
        return;
      }
      crashIdList.push(crashId);
      crashDatas[crashId] = { ...item, crashId };
    });
    return {
      crashIdList,
      crashDatas,
      numFound: totalCount || crashIdList.length,
      searchParams: { start: 0, rows: crashIdList.length || 10 },
    };
  },
});